import { state, mutations } from './mutations';
import * as getters from './getters';

export default {
  name: 'taskengine',
  state,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/modules/TaskEngine/_store/index.js